import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSectionBoot';
import DivLayout from 'components/sales/divLayout/divLayout';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import moment from 'moment';

const ProjectPmAssignTicket = ({
  fetchPmAssignee,
  postScheduleProjectPM,
  pmAssigneeList,
  fetchProjectPmSlotDetails,
  projectPmSlotDetails=[],
  match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [maintenanceDate, setMaintenanceDate] = useState('');
  const [assigneeId, setassigneeId] = useState('');
  const [assigneeName, setassigneeName] = useState('');
  const [slotBooked, setSlotBooked] = useState('');
  const [isModal, setIsModal] = useState(false);
  const [formState, setFormState] = useState([]);
  
  useEffect(() => {
    const initialState = projectPmSlotDetails.map((slotDetail) => ({
      maintenance_date: moment().format("DD-MM-YYYY"), 
      assignee_id: "", 
      slot: "",
      assignee_name: "",
      pm_site_id:slotDetail?.pm_ticket_id,
      pm_ticket_id:slotDetail?.pm_ticket_id
    }));
    setFormState(initialState);
  }, [projectPmSlotDetails]);

  console.log(formState);
  // Handle changes dynamically for each slot
  const handleSlotChange = (index, key, value) => {
    const updatedFormState = [...formState];
    if (!updatedFormState[index]) {
      updatedFormState[index] = {}; // Initialize if not already defined
    }
    updatedFormState[index][key] = value;
    setFormState(updatedFormState);
  };
  
  const headerBtns = () => {
    return (
      <Fragment>
        <Link to="#" onClick={() => onAssign()} className="btn btn-primary">
          <img src={Images?.ArrowRight} alt=""></img>
          {localization.assign}
        </Link>
      </Fragment>
    );
  };

  // useEffect(() => {
  //   (async () => {
  //     const date =
  //       (await JSON.parse(localStorage.getItem('viewDetail'))) &&
  //       JSON.parse(localStorage.getItem('viewDetail'))[0].maintaince_date;
  //     handleDateChange(date);

  //     const assignee_id =
  //       (await JSON.parse(localStorage.getItem('viewDetail'))) &&
  //       JSON.parse(localStorage.getItem('viewDetail'))[0].assigned_to_id;

  //     const slot_selection =
  //       (await JSON.parse(localStorage.getItem('viewDetail'))) &&
  //       JSON.parse(localStorage.getItem('viewDetail'))[0].slot;
  //     if(slot_selection !== null && slot_selection !== undefined) {
  //       setSlotBooked(slot_selection);
  //     }

  //     const assigneeName =
  //       (await JSON.parse(localStorage.getItem('viewDetail'))) &&
  //       JSON.parse(localStorage.getItem('viewDetail'))[0].assigned_to;
  //     setMaintenanceDate(date);
  //     setassigneeId(assignee_id);
  //     setassigneeName(assigneeName);
  //   })();
  // }, []);

  useEffect(() => {
      (async () => {
        console.log(fetchPmAssignee)
  
        if (fetchPmAssignee) {
          setIsLoading(true);
          await fetchPmAssignee(match.params.manageId);
          await fetchProjectPmSlotDetails(match.params.id,match.params.manageId);
          setIsLoading(false);
        }
      })();
    }, [fetchPmAssignee]);
  
    const onAssign = async () => {
      const isFormValid = formState.every(
        (slot) =>
          slot.maintenance_date && slot.assignee_id && slot.slot 
      );
  
      if (isFormValid) {
        setIsLoading(true);
        const res = await postScheduleProjectPM(formState);
        setIsLoading(false);
  
        if (res === true) {
          setIsModal(true);
        } else {
          setIsModal(false);
        }
      } else {
        alert("Please fill all required fields for all slots.");
      }
    };


  const handleDateChange = (val) => {
    setMaintenanceDate(val);
  };

  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    (async () => {
      if (fetchPmAssignee) {
        setIsLoading(true);
        await fetchPmAssignee(match.params.id);
        setIsLoading(false);
      }
    })();
  }, [fetchPmAssignee]);

  return (
    <Layout
      title={localization.managePm}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
      linkUrl={`${baseUrl}/pm-projects`}
    >
      <h4 style={{"marginBottom": "10px"}}>{localization.schedulePm}</h4>
      {projectPmSlotDetails && projectPmSlotDetails.map((slotDetail,index) => {
        return(
        <CardSection title={`${slotDetail?.client_name} (${slotDetail?.site_no})`} >
        <div className="row">
            <div className="col-12">
                <div className="details-listing">
                <DivLayout
                  heading={localization.currentMaintenanceDate}
                  data={slotDetail?.maintenance_date}
                />
              </div>
            </div>
            </div>
            <div className="row">
              
              <div className="col-md-6 col-sm-12">
                  <DatePicker
                    handleChange={(date) => {
                      console.log("DATE",moment(date).format("DD-MM-YYYY"))
                      handleSlotChange(index, "maintenance_date", moment(date, "DD-MM-YYYY").format("DD-MM-YYYY"))
                    }}
                    value={formState[index]?.maintenanceDate || moment(slotDetail?.maintenance_date, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                    label={localization.scheduleMaintenanceDate}
                    displayFormat="DD-MM-YYYY"
                    returnFormat="DD-MM-YYYY"
                    minimumDate={new Date()}
                  />
              </div>
              <div className="col-md-6 col-sm-12">
                  <DropDownInput
                    label={localization.selectAssignee}
                    data={pmAssigneeList}
                    required
                    isStarRequired={true}
                    getIdValue={(val) => {
                      handleSlotChange(index, "assignee_id", val.id)
                      handleSlotChange(index, "assignee_name", val.name)
                    }}
                    value={formState[index]?.assigneeName || ""}
                  />
              </div>
              <div className="col-md-6 col-sm-12">
                  <DropDownInput
                    label={`Select Slot`}
                    data={[
                      {name: "09:00 am",id: "09:00 am"},
                      {name: "10:00 am",id: "10:00 am"},
                      {name: "11:00 am",id: "11:00 am"},
                      {name: "12:00 pm",id: "12:00 pm"},
                      {name: "13:00 pm",id: "13:00 pm"},
                      {name: "14:00 pm",id: "14:00 pm"},
                      {name: "15:00 pm",id: "15:00 pm"},
                      {name: "16:00 pm",id: "16:00 pm"},
                      {name: "17:00 pm",id: "17:00 pm"},
                      {name: "18:00 pm",id: "18:00 pm"},
                      {name: "19:00 pm",id: "19:00 pm"},
                      {name: "20:00 pm",id: "20:00 pm"},
                      {name: "21:00 pm",id: "21:00 pm"},
                    ]}
                    required
                    isStarRequired={true}
                    getIdValue={(val) => handleSlotChange(index, "slot", val.id)}
                    value={formState[index]?.slot || ""}
                  />
              </div>
            </div>
        </CardSection>
        )
      })}
      

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.assignedSuccessfully}</h5>
          <Link to={`${baseUrl}/pm-projects`} className="btn btn-primary mb-4">
            {localization.viewPmList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ProjectPmAssignTicket;
